// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.layout{
    display: flex;
    max-width: 100vw;
}
p {

  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 10px;
  margin-inline-end: 10px;
}

body {
    overflow: hidden; 
  }
  
  .content {
 
    width: 100%;
    height: 100vh;
    overflow: auto; 
  }
  
  
  .content::-webkit-scrollbar {
    width: 0;
  }

  
  .menu{
    width: 35px;
    height:35px;
    background-color: red;
  }

  .menu img{
    width: 100%;
    height: 100%;
    cursor: pointer;
  }
  
 
@media screen and (min-width:768px) {
  .menu{
    display: none;
  }

}
.sidebar {
  width: 250px; /* Default width for desktop */
  flex-shrink: 0;
  background-color: rgba(22, 22, 22, 1);
  height: 100vh;
  overflow: auto;
  color: #fff;
}

.sidebar-item {
  padding: .75em 1em;
  display: block;
  transition: background-color .15s;
  border-radius: 5px;
  cursor: pointer;
}

.sidebar-item:hover {
  background-color: rgba(255, 255, 255, .1);
}

.logo {
  margin: 40px;
}

.sidebar-item-plane {
  padding-top: 5px;
  margin-bottom: 100px;
}

.sidebar-item {
  background-color: #333;
  color: white;
  font-size: 15px;
  padding: 10px;
  margin-bottom: 5px;
}

.sidebar-item.open {
  background-color: #555;
}

.sidebar-title {
  display: flex;
  align-items: center;
}

.sidebar-content {
  padding-left: 20px;
}

.sidebar-item.plain {
  text-decoration: none;
  color: white;
}

.toggle-btn {
  cursor: pointer;
  margin-left: auto;
}

/* Styling for icon */
.sidebar-item i {
  margin-right: 5px;
}

/* Media query for mobile devices */
@media screen and (max-width: 768px) {
  .sidebar {
    width: 200px; /* Adjusted width for mobile */
  }

  .sidebar-item {
    padding: .5em 1em; /* Adjusted padding for mobile */
  }
  .hidden-mobile {
    display: none;
}
}

.hamburger-icon {
  position: absolute;
  top: 10px; /* Adjust the distance from the top */
  right: 25px; /* Adjust the distance from the right */
  cursor: pointer;
}

/* Optional: Add styles for the image if needed */
.hamburger-icon img {
  width: 35px; /* Adjust width as needed */
  height: 35px; /* Adjust height as needed */
}
`, "",{"version":3,"sources":["webpack://./src/components/layout/layout.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,gBAAgB;AACpB;AACA;;EAEE,uBAAuB;EACvB,qBAAqB;EACrB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;IACI,gBAAgB;EAClB;;EAEA;;IAEE,WAAW;IACX,aAAa;IACb,cAAc;EAChB;;;EAGA;IACE,QAAQ;EACV;;;EAGA;IACE,WAAW;IACX,WAAW;IACX,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;;AAGF;EACE;IACE,aAAa;EACf;;AAEF;AACA;EACE,YAAY,EAAE,8BAA8B;EAC5C,cAAc;EACd,qCAAqC;EACrC,aAAa;EACb,cAAc;EACd,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iCAAiC;EACjC,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA,qBAAqB;AACrB;EACE,iBAAiB;AACnB;;AAEA,mCAAmC;AACnC;EACE;IACE,YAAY,EAAE,8BAA8B;EAC9C;;EAEA;IACE,iBAAiB,EAAE,gCAAgC;EACrD;EACA;IACE,aAAa;AACjB;AACA;;AAEA;EACE,kBAAkB;EAClB,SAAS,EAAE,qCAAqC;EAChD,WAAW,EAAE,uCAAuC;EACpD,eAAe;AACjB;;AAEA,iDAAiD;AACjD;EACE,WAAW,EAAE,2BAA2B;EACxC,YAAY,EAAE,4BAA4B;AAC5C","sourcesContent":[".layout{\r\n    display: flex;\r\n    max-width: 100vw;\r\n}\r\np {\r\n\r\n  margin-block-start: 1em;\r\n  margin-block-end: 1em;\r\n  margin-inline-start: 10px;\r\n  margin-inline-end: 10px;\r\n}\r\n\r\nbody {\r\n    overflow: hidden; \r\n  }\r\n  \r\n  .content {\r\n \r\n    width: 100%;\r\n    height: 100vh;\r\n    overflow: auto; \r\n  }\r\n  \r\n  \r\n  .content::-webkit-scrollbar {\r\n    width: 0;\r\n  }\r\n\r\n  \r\n  .menu{\r\n    width: 35px;\r\n    height:35px;\r\n    background-color: red;\r\n  }\r\n\r\n  .menu img{\r\n    width: 100%;\r\n    height: 100%;\r\n    cursor: pointer;\r\n  }\r\n  \r\n \r\n@media screen and (min-width:768px) {\r\n  .menu{\r\n    display: none;\r\n  }\r\n\r\n}\r\n.sidebar {\r\n  width: 250px; /* Default width for desktop */\r\n  flex-shrink: 0;\r\n  background-color: rgba(22, 22, 22, 1);\r\n  height: 100vh;\r\n  overflow: auto;\r\n  color: #fff;\r\n}\r\n\r\n.sidebar-item {\r\n  padding: .75em 1em;\r\n  display: block;\r\n  transition: background-color .15s;\r\n  border-radius: 5px;\r\n  cursor: pointer;\r\n}\r\n\r\n.sidebar-item:hover {\r\n  background-color: rgba(255, 255, 255, .1);\r\n}\r\n\r\n.logo {\r\n  margin: 40px;\r\n}\r\n\r\n.sidebar-item-plane {\r\n  padding-top: 5px;\r\n  margin-bottom: 100px;\r\n}\r\n\r\n.sidebar-item {\r\n  background-color: #333;\r\n  color: white;\r\n  font-size: 15px;\r\n  padding: 10px;\r\n  margin-bottom: 5px;\r\n}\r\n\r\n.sidebar-item.open {\r\n  background-color: #555;\r\n}\r\n\r\n.sidebar-title {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.sidebar-content {\r\n  padding-left: 20px;\r\n}\r\n\r\n.sidebar-item.plain {\r\n  text-decoration: none;\r\n  color: white;\r\n}\r\n\r\n.toggle-btn {\r\n  cursor: pointer;\r\n  margin-left: auto;\r\n}\r\n\r\n/* Styling for icon */\r\n.sidebar-item i {\r\n  margin-right: 5px;\r\n}\r\n\r\n/* Media query for mobile devices */\r\n@media screen and (max-width: 768px) {\r\n  .sidebar {\r\n    width: 200px; /* Adjusted width for mobile */\r\n  }\r\n\r\n  .sidebar-item {\r\n    padding: .5em 1em; /* Adjusted padding for mobile */\r\n  }\r\n  .hidden-mobile {\r\n    display: none;\r\n}\r\n}\r\n\r\n.hamburger-icon {\r\n  position: absolute;\r\n  top: 10px; /* Adjust the distance from the top */\r\n  right: 25px; /* Adjust the distance from the right */\r\n  cursor: pointer;\r\n}\r\n\r\n/* Optional: Add styles for the image if needed */\r\n.hamburger-icon img {\r\n  width: 35px; /* Adjust width as needed */\r\n  height: 35px; /* Adjust height as needed */\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
